<div>
    <button v-if="came_from_dashboard"
    class="btn btn-sm text-xs border-0 rounded bg-transparent d-flex align-items-center  ms-3 mt-2 fw-bold"
    @click="go_back_to_dashboard">
    <i class="fa-solid fa-circle-arrow-left fa-lg me-2"></i> Back
  </button>
  <!-- MAIN CARD -->
  <div class="ms-4">
    <p class="text-xl fw-bold mb-0">Trust Documents</p>
    <p class="text-xs text-dark mb-0">
      View-only access to trust master documents. Downloads and prints are disabled for security.
    </p>
  </div>

  <div class="px-3">

    <div class="quick-tip border-0 d-flex align-items-center gap-2 py-2 px-3 mt-3 mb-4 rounded-lg bg-primary-blue">
      <i class="fas fa-lock text-white"></i>
      <span class="text-xs text-white">
        All documents are <strong>view-only</strong>. Downloads, printing, and copying are disabled. Your viewing
        activity is logged for audit purposes.
      </span>
    </div>

    <div class="d-flex align-items-center gap-2 mb-4 overflow-auto px-1 d-none">
      <div class="input-group input-group-sm w-30 rounded overflow-hidden col-md-8">
        <span class="input-group-text bg-light-gray border-end-0 rounded">
          <i class="bi bi-search text-muted"></i>
        </span>
        <input type="text" class="form-control form-control-sm border-start-0 ps-0 text-xxs bg-light-gray"
          placeholder="Search">
      </div>


      <div class="mt-2 ms-1 nav-tabs nav-tabs-navigation p-0">
        <div class="nav-tabs-wrapper d-flex flex-wrap">
          <button v-for="(tab, index) in tabs" :key="index" @click="set_active_tab(tab)" :class="[
              'btn btn-sm px-3 text-xs me-2 mb-2',
              active_tab === tab 
                ? 'bg-primary-blue text-white border-0 rounded' 
                : 'btn-primary-dark text-dark border-0 rounded'
            ]">
            {{ tab }}
          </button>
        </div>
      </div>

    </div>
  </div>


  <div class="p-3 rounded-lg">
    <div v-if="table_safe_documents.length > 0" class="row">

      <!-- LEFT: DOCUMENT LIST -->
      <div class="col-md-5 document-list">

        <div v-for="(doc, index) in table_safe_documents" :key="index"
          class="document-card d-flex justify-content-between align-items-center shadow-sm mb-3 rounded-lg bg-light"
          :class="{ active: selected_document === doc }" @click="select_document(doc)">
          <div class="d-flex align-items-start gap-3 px-2 p-2">
            <div class="icon-box mt-2 icon-green">
              <i class="bi bi-file-earmark-text fs-4 text-primary-blue"></i>
            </div>
            <div>
              <div class="fw-500 text-xs">
                {{ doc.file_name }}
              </div>
              <div class="text-muted text-xxs mt-1">
                {{ doc.section }} • {{ format_date(doc.submitted_on) }}
              </div>
              <span class="status-badge mt-2 text-xxs fw-semibold"
                :class="doc.is_verified ? 'bg-success text-white' : 'bg-warning text-dark'">
                {{ doc.is_verified ? 'Verified' : 'Pending Verification' }}
              </span>
            </div>

          </div>
          <i class="far fa-eye fs-6 me-3"></i>

        </div>
      </div>

      <!-- RIGHT: PREVIEW PANEL -->
      <div class="col-md-7">
        <div class="preview-panel p-3 rounded-lg bg-light shadow-sm">
          <div v-if="selected_document">
            <h6 class="fw-bold mb-3">Document Preview</h6>
            <div class="preview-container mb-3">
              <iframe v-if="selected_document.presigned_url" :src="selected_document.presigned_url" width="100%"
                height="700" class="rounded"></iframe>
            </div>

            <div class="text-xs">
              <p><strong>Document : </strong> {{ selected_document.file_name }}</p>
              <p><strong>Section : </strong> {{ selected_document.section }}</p>
              <p>
                <strong>Status : </strong>
                <span :class="selected_document.is_verified ? 'text-success' : 'text-warning'">
                  {{ selected_document.is_verified ? 'Verified' : 'Pending Verification' }}
                </span>
              </p>
            </div>

            <div class="mt-3 d-flex gap-2">
              <button class="btn btn-primary-dark btn-sm text-xxs shadow"
                @click="download_file(selected_document.presigned_url, selected_document.file_name)">
                Download
              </button>
            </div>
          </div>
          <div v-else class="text-muted text-center py-5">
            Select a document to preview
          </div>
        </div>
      </div>

    </div>
    <div v-else class="p-4 text-center text-muted">
      No documents available.
    </div>
  </div>

</div>